import { RequestContext } from "./generated/runtime";
import { PropertyTypesApi, Configuration } from "./generated";
import { appConfig } from "@shared/utils/appConfig";

async function preMiddleware(context: RequestContext) {
  return context;
}

function getConfig() {
  return new Configuration({
    basePath: `${appConfig.PROPERTY_SEARCH_API_URL}`,
  });
}

// PROPERTY TYPES API
export const getPropertyTypesApiClient = (): PropertyTypesApi => {
  return new PropertyTypesApi(getConfig()).withPreMiddleware(preMiddleware);
};
